import type { ReactNode } from "react";
import type { Binding } from "@/app/types";
import { useResourceViewStore } from "./hooks/use-resource-view";
import { HorizontalResourceView } from "./horizontal-resource-view";
import { VerticalResourceView } from "./vertical-resource-view";

export type ResourceSection = {
  binding: Binding;
  itemsCount: number;
  resourceType: string;
  defaultOpen?: boolean;
  overriddenCount?: number;
  overriddenTooltipContent?: string;
  children?: ReactNode;
};

type ResourceContainerProps = {
  sections: ResourceSection[];
  title?: string;
  description?: string;
  className?: string;
  defaultActiveTab?: string;
};

export const ResourceContainer = ({
  sections,
  title,
  description,
  className,
  defaultActiveTab,
}: ResourceContainerProps) => {
  const { viewType } = useResourceViewStore();

  return (
    <div className={className}>
      {/* Optional Header section - only show if explicitly provided */}
      {!!(title || description) && (
        <div className="mb-6 space-y-1">
          {!!title && (
            <h2 className="font-semibold text-foreground text-xl tracking-tight">
              {title}
            </h2>
          )}
          {!!description && (
            <p className="text-muted-foreground text-sm leading-relaxed">
              {description}
            </p>
          )}
        </div>
      )}

      {/* Content section */}
      <div>
        {viewType === "horizontal" ? (
          <HorizontalResourceView
            defaultActiveTab={defaultActiveTab}
            sections={sections}
          />
        ) : (
          <VerticalResourceView sections={sections} />
        )}
      </div>
    </div>
  );
};
